import { PenLine } from 'lucide-react';
import { Dialog, DialogContent, DialogTrigger } from '../../components/ui/dialog';
import useAuth from '../../stores/useAuth';
import { FormChangeEmail, FormName, FormPassword } from './FormUpdate';
import Skeleton from '../../components/ui/skeleton';

export default function UserProfile() {
  const { dataUser, loading } = useAuth();
  return (
    <div className="flex md:flex-row flex-col gap-4 text-text">
      {/* Column Left */}
      <div className="border border-border rounded-lg p-4 flex-1 flex flex-col gap-4">
        <h3 className="text-base font-semibold">User Profile</h3>
        <div className="flex flex-col gap-4">
          {/* Row Name */}
          <div className="flex flex-col gap-1">
            <p className="font-semibold text-sm">Name</p>
            <div className="flex justify-between items-center">
              {loading ? (
                <Skeleton className="h-4 w-1/4 bg-slate-200" />
              ) : (
                <p className="font-normal text-sm">{dataUser?.name}</p>
              )}
              <Dialog>
                <DialogTrigger>
                  <span className="flex gap-1 items-center justify-center text-blue-700 text-sm">
                    <PenLine size={14} />
                    Edit
                  </span>
                </DialogTrigger>
                <DialogContent className="max-w-xs md:max-w-xl rounded-md">
                  <FormName />
                </DialogContent>
              </Dialog>
            </div>
          </div>

          {/* Row User Email */}
          <div className="flex flex-col gap-1">
            <p className="font-semibold text-sm">User Email</p>
            <div className="flex justify-between items-center">
              {loading ? (
                <Skeleton className="h-4 w-1/4 bg-slate-200" />
              ) : (
                <p className="font-normal text-sm">{dataUser?.email}</p>
              )}
              <Dialog>
                <DialogTrigger>
                  <span className="flex gap-1 items-center justify-center text-blue-700 text-sm">
                    <PenLine size={14} />
                    Edit
                  </span>
                </DialogTrigger>
                <DialogContent className="max-w-xs md:max-w-xl rounded-md">
                  <FormChangeEmail />
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </div>
      </div>

      {/* Column Right */}
      <div className="border border-border rounded-lg p-4 flex-1 flex flex-col gap-4 h-max">
        <h3 className="text-base font-semibold">Password</h3>
        <div className="flex flex-col gap-2">
          <div className="flex justify-between items-center">
            <p className="font-normal text-sm">Change Password</p>
            <Dialog>
              <DialogTrigger>
                <span className="flex gap-1 items-center justify-center text-blue-700 text-sm">
                  <PenLine size={14} />
                  Edit
                </span>
              </DialogTrigger>
              <DialogContent className="max-w-xs md:max-w-xl rounded-md">
                <FormPassword />
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </div>
    </div>
  );
}
